import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { profileApi } from '../../api';
import { useAuth } from '../../hooks/useAuth';

/** URL (object URL) de la foto de perfil del usuario autenticado, o `null` si no tiene. Se renueva al cambiar `avatarKey`. */
export function useAvatarUrl(): string | null {
  const avatarKey = useAuth((s) => s.user?.avatarKey ?? null);
  const { data: blob } = useQuery({
    queryKey: ['profile', 'avatar', avatarKey],
    queryFn: () => profileApi.getAvatar(),
    enabled: !!avatarKey,
    retry: false,
    staleTime: Infinity,
  });
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob || !avatarKey) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob, avatarKey]);

  return avatarKey ? url : null;
}
